/* eslint-disable jsx-a11y/anchor-is-valid */
import {Suspense, lazy, useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { HOUSELINKS } from '../../../data/constants'

const Registration = lazy(() =>
  import('./components/Registration').then((m) => ({default: m.Registration}))
)
const ForgotPassword = lazy(() =>
  import('./components/ForgotPassword').then((m) => ({default: m.ForgotPassword}))
)
const VerificationCode = lazy(() =>
  import('./components/VerificationCode').then((m) => ({default: m.VerificationCode}))
)

const rootContainerStyle = {
  height: '100vh',
  overflow: 'hidden',
} as const

const portalInfoStyle = {
  position: 'relative',
  backgroundColor: '#1c1c1c',
} as const

const portalAsterickImgStyle = {
  backgroundImage: `url(${toAbsoluteUrl('/assets/streamline-asterick.svg')})`,
  backgroundRepeat: 'no-repeat',
  width: '25px',
  height: '25px',
  marginBottom: '1em',
} as const

const portalTitleStyle = {
  color: '#858585',
  lineHeight: '1.5em',
  fontWeight: 'normal',
  fontSize: '14px',
} as const

const outletWrapperStyle = {
  height: '90vh',
  overflowY: 'auto',
} as const

const footerTextStyle = {
  fontSize: '11px',
} as const

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    const rootEl = document.getElementById('root');
    if (rootEl) {
      rootEl.style.height = '100%';
    }
    return () => {
      document.body.classList.remove('bg-white')
      if (rootEl) {
        rootEl.style.height = '';
      }
    }
  }, [])
  return (
    <div className='d-flex flex-column flex-root' style={rootContainerStyle}>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
        {/* begin::Content */}
        <div id='portal-info' className='d-flex flex-column flex-lg-row-fluid w-lg-30 p-10 order-2 order-lg-1'
        style={portalInfoStyle}
        >
        <div><img style={{width: '100px'}} width={100} height={78} src={toAbsoluteUrl('/assets/streamline-logo.svg')} alt="Streamline" /></div>
        <div id='portal-asterick'>
          <div className='portal-asterick-img' style={portalAsterickImgStyle}></div>
          <h2 style={portalTitleStyle}>
            Verify identities of people and businesses instantly — simply pay per verification with zero initial setup cost.
            </h2>
        </div>
        </div>
        <div className='flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        >
          <div className='d-flex flex-center flex-column flex-lg-row-fluid' id='outlet-wrapper-registration' style={outletWrapperStyle}>
            <div className='w-lg-600px p-10'>
              <Outlet />
            </div>
          </div>
          <div className='d-flex flex-center flex-wrap px-5'>
              <div className='d-flex fw-semibold text-primary fs-base'>
                <a href={HOUSELINKS.about} target='_blank' rel='noopener noreferrer' className='text-muted text-hover-primary px-2'>
                  About
                </a>

                <a href={HOUSELINKS.support} target='_blank' rel='noopener noreferrer' className='text-muted text-hover-primary px-2'>
                  Support
                </a>

                <a href={HOUSELINKS.legal} target='_blank' rel='noopener noreferrer' className='text-muted text-hover-primary px-2'>
                  Legal
                </a>
              </div>
          </div>
          <div className='d-flex flex-center flex-wrap px-5 mt-3'>
              <div className='d-flex text-muted' style={footerTextStyle}>
                  STREAMLINE Flex by Laboremus Uganda Limited
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route
        path='registration'
        element={
          <Suspense fallback={null}>
            <Registration />
          </Suspense>
        }
      />
      <Route
        path='verification'
        element={
          <Suspense fallback={null}>
            <VerificationCode />
          </Suspense>
        }
      />
      <Route
        path='forgot-password'
        element={
          <Suspense fallback={null}>
            <ForgotPassword />
          </Suspense>
        }
      />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)
export {AuthPage}
